/**
 * Token Manager for API Interceptors
 * 
 * This module provides token storage and management functionality
 * for API interceptors without creating circular dependencies.
 * 
 * It's a simplified version of AuthTokenManager specifically for
 * use in API interceptors.
 */

/**
 * Token storage and management
 */
class TokenManager {
  static getAccessToken() {
    try {
      return localStorage.getItem('arbiwin_auth_token');
    } catch (error) {
      console.warn('Failed to get access token from localStorage:', error);
      return null;
    }
  }

  static getRefreshToken() {
    try {
      return localStorage.getItem('arbiwin_refresh_token');
    } catch (error) {
      console.warn('Failed to get refresh token from localStorage:', error);
      return null;
    }
  }

  static setTokens(accessToken, refreshToken, expiresIn) {
    try {
      localStorage.setItem('arbiwin_auth_token', accessToken);
      localStorage.setItem('arbiwin_refresh_token', refreshToken);
      localStorage.setItem('arbiwin_token_expires', Date.now() + (expiresIn * 1000));
      console.log('Tokens stored successfully');
    } catch (error) {
      console.error('Failed to store tokens:', error);
    }
  }

  static clearTokens() {
    try {
      localStorage.removeItem('arbiwin_auth_token');
      localStorage.removeItem('arbiwin_refresh_token');
      localStorage.removeItem('arbiwin_token_expires');
      localStorage.removeItem('arbiwin_user_info');
      console.log('Tokens cleared successfully');
    } catch (error) {
      console.error('Failed to clear tokens:', error);
    }
  }

  static isTokenExpired(token) {
    if (!token) return true;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const now = Math.floor(Date.now() / 1000);
      return payload.exp < now;
    } catch (error) {
      console.warn('Failed to parse token:', error);
      return true;
    }
  }

  static getTokenExpiration(token) {
    if (!token) return null;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp * 1000; // Convert to milliseconds
    } catch (error) {
      console.warn('Failed to get token expiration:', error);
      return null;
    }
  }
}

export { TokenManager };
